import React, { PureComponent, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import PassengerSeat from 'components/AirlineSeatSelection/PassengerSeat';
import CollapsiblePanel from 'components/CollapsiblePanel/CollapsiblePanel';
import LinkButton from 'components/LinkButton/LinkButton';
import BookPrice from 'components/BookPrice/BookPrice';

import { capitalize } from 'utils/utils';
import { findFlightSeat } from 'reducers/bookStateUtils';
import { fireEvent } from 'utils/optimizely';

import './PassengerListFlight.scss';

export default class PassengerListFlight extends PureComponent {
  static propTypes = {
    direction: PropTypes.string.isRequired,
    flight: ImmutablePropTypes.contains({
      deptName: PropTypes.string.isRequired,
      arrvName: PropTypes.string.isRequired,
    }).isRequired,
    seatPassengers: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
      id: PropTypes.number.isRequired,
      counter: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      paxType: PropTypes.string.isRequired,
    })),
    openSeatList: PropTypes.func.isRequired,
    flightSeatsSelection: ImmutablePropTypes.map.isRequired,
    clearSelection: PropTypes.func.isRequired,
  };

  static defaultProps = {
    seatPassengers: Immutable.List(),
  };

  handleSelectEveryoneClick = (event) => {
    event.preventDefault();

    const { openSeatList, direction } = this.props;
    fireEvent(`BookSeatSelection${capitalize(direction)}AllPassengers`, 'clicked');

    openSeatList(direction);
  };

  handleSelectPassengerClick = (event) => {
    event.preventDefault();

    const { openSeatList, direction } = this.props;
    const currentPassengerIndex = Number(event.currentTarget.dataset.index);
    fireEvent(`BookSeatSelection${capitalize(direction)}SinglePassenger`, 'clicked');

    openSeatList(direction, currentPassengerIndex);
  };

  getFlightSeatForPassenger(passengerSelection) {
    const { flight } = this.props;
    return findFlightSeat(flight, passengerSelection.get('row'), passengerSelection.get('seat'));
  }

  handleClearSelectionClick = (event) => {
    const { clearSelection, direction } = this.props;
    fireEvent(`BookSeatSelection${capitalize(direction)}ClearSelection`, 'clicked');

    event.preventDefault();

    clearSelection(direction);
  };

  render() {
    const { direction, flight, seatPassengers, flightSeatsSelection } = this.props;

    const hasSeatsSelected = flightSeatsSelection.size > 0;

    return (
      <div className="passenger-list-flight">
        <CollapsiblePanel label={`${capitalize(direction)}: ${flight.get('deptName')} > ${flight.get('arrvName')}`}>
          <div>
            { hasSeatsSelected && (
              <div className="passenger-list-flight__clear-selection-button" onClick={this.handleClearSelectionClick}>
                Clear all selections
              </div>
            )}
            {
              seatPassengers.map((passenger, index) => (
                <div className="passenger-list-flight__passenger" key={passenger.get('id')} data-index={index} onClick={this.handleSelectPassengerClick}>
                  <div className="passenger-list-flight__seat-icon">
                    <PassengerSeat counter={passenger.get('counter')} paxType={passenger.get('paxType')} />
                  </div>
                  <div className="passenger-list-flight__passenger__details">
                    <div className="passenger-list-flight__passenger__details__label">{passenger.get('label')}:</div>
                    {
                      flightSeatsSelection.has(`${passenger.get('id')}`) ? (
                        <div className="passenger-list-flight__passenger__details__reservation">
                          Seat: {flightSeatsSelection.getIn([`${passenger.get('id')}`, 'row'])}{flightSeatsSelection.getIn([`${passenger.get('id')}`, 'seat'])}

                          <div className="passenger-list-flight__passenger__details__reservation__price">
                            <BookPrice
                              price={this.getFlightSeatForPassenger(flightSeatsSelection.get(`${passenger.get('id')}`)).getIn(['flightSeatPrice', 'webPrice'])}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="passenger-list-flight__passenger__details__reservation">No reservation</div>
                      )
                    }
                  </div>
                </div>
              ))
            }
            <LinkButton onClick={this.handleSelectEveryoneClick} color="blue" type="secondary">Select seats for everyone</LinkButton>
          </div>
        </CollapsiblePanel>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/PassengerListFlight.jsx
 **/